import React, { useContext } from 'react';
import Section from './section';
import { Context as HeaderFooterContext } from '../../../shared/context/Assets-Context';


const OnBoarding = ({ content }) => {
    const sections = content && content.section && !!content.section.length && content.section;
    const { state } = useContext(HeaderFooterContext);
    const cookieBox = state.headerFooterContent && state.headerFooterContent.cookie_box_content;
    return (
        <div className='onboarding-pg'>

            <div className="onborAdalternateImageInfo-box">
                <div className="container">

                    {/* onboard row start */ }
                    {
                        sections && !!sections.length && sections.map((obj, index) => {
                            return (
                                <Section className={ `section${index + 1}` } key={ index }>
                                    <div className="onboardrow">
                                        <div className="row-wrap">
                                            {/* image section start */ }
                                            <div className="box-12 box-md-6 img-box">

                                                {
                                                    obj.image &&
                                                    <div className={ `inner-box customAnim section${index + 1} ${index % 2 === 0 ? 'slide-right' : 'slide-left'} ` }>
                                                        <figure>
                                                            <img src={ obj.image.url } alt="banner" />
                                                        </figure>
                                                    </div>
                                                }


                                            </div>
                                            {/* image section end */ }

                                            {/* info section start */ }
                                            <div className="box-12 box-md-6 content-box">
                                                <div className="inner-box">
                                                    <div className="intro-box p-18">

                                                        <h2 className={ `heading has-line left-line section${index + 1} ${index % 2 === 0 ? 'slide-left' : 'slide-right'}` }>{ obj.title }</h2>
                                                        <div dangerouslySetInnerHTML={ { __html: obj.content } }>

                                                        </div>
                                                        {
                                                            obj.cta_links && !!obj.cta_links.length &&
                                                            <div className="app-button customAnim section1 slide-left">
                                                                {
                                                                    obj.cta_links && !!obj.cta_links.length && obj.cta_links.map(({ link, image }, linkIndex) => {
                                                                        return (
                                                                            <React.Fragment key={ linkIndex }>
                                                                                { link &&
                                                                                    <a href={ link.url } target={ link.target !== "" ? "_blank" : "_self" } rel="noreferrer">
                                                                                        {
                                                                                            image &&
                                                                                            <img src={ image.url } alt="app-store" />
                                                                                        }
                                                                                    </a>
                                                                                }

                                                                            </React.Fragment>
                                                                        );
                                                                    })
                                                                }

                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                            </div>
                                            {/* info section end */ }

                                        </div>
                                    </div>

                                </Section>
                            );
                        })
                    }


                </div>
            </div>

            <CookieBox cookieBox={ cookieBox } />
        </div>
    );
};

const CookieBox = ({ cookieBox }) => {
    return (
        <div className="cookies-box">
            <div className="container">
                <div className="row-wrap">
                    <div className="box-12">
                        <div className="inner-box">
                            <div className="info-box" dangerouslySetInnerHTML={ { __html: cookieBox } }>
                                {/* <p>We use cookies to improve your browsing experience. By continuing, you agree to our <a href="#">cookie policy</a>.</p> */ }
                            </div>
                            <div className="button-box">
                                <a href="#" target="_self" className="button button-outline">Accept</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const dummy = props => {
    return <>
        <Section className="section1">
            <div className="onboardrow">
                <div className="row-wrap">
                    {/* image section start */ }
                    <div className="box-12 box-md-6 img-box">

                        <div className="inner-box customAnim section1 slide-right">
                            <figure>
                                <img src={ `${process.env.PUBLIC_URL}/images/section1-img.png` } alt="banner" />
                            </figure>
                        </div>

                    </div>
                    {/* image section end */ }

                    {/* info section start */ }
                    <div className="box-12 box-md-6 content-box">
                        <div className="inner-box">
                            <div className="intro-box p-18">

                                <h2 className="heading has-line left-line customAnim section1 slide-left">How to Open a Personal Account?</h2>

                                <p className="customAnim section1 slide-left">Enjoy quick and simple onboarding on mobile devices. All you have to do is:</p>

                                <ol>

                                    <li className="customAnim section1 slide-left">Download the Demivolt app </li>

                                    <li className="customAnim section1 slide-left">Register and complete a short (KYC) questionnaire</li>

                                </ol>

                                <p className="customAnim section1 slide-left">After automated identity verifications and Demivolt's confirmation you will be able to use your account.</p>
                                <div className="app-button customAnim section1 slide-left">
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src="https://dev.project-progress.net/projects/demivolt/wp-content/uploads/2020/12/apple_store_label.svg" alt="app-store" />
                                    </a>
                                    <a href="#" target="_blank" rel="noreferrer">
                                        <img src="https://dev.project-progress.net/projects/demivolt/wp-content/uploads/2020/12/google_play_label.svg" alt="google-play" />
                                    </a>
                                </div>
                            </div>
                        </div>

                    </div>
                    {/* info section end */ }

                </div>
            </div>


        </Section>
        {/* onboard row end */ }

        {/* onboard row start */ }
        <Section className="section2">
            <div className="onboardrow">
                <div className="row-wrap">
                    {/* image section start */ }
                    <div className="box-12 box-md-6 img-box">
                        <div className="inner-box customAnim section2 slide-left">
                            <figure>
                                <img src={ `${process.env.PUBLIC_URL}/images/section2-img.png` } />
                            </figure>
                        </div>
                    </div>
                    {/* image section end */ }

                    {/* info section start */ }
                    <div className="box-12 box-md-6 content-box">
                        <div className="inner-box">
                            <div className="intro-box p-18">
                                <h2 className="heading has-line left-line customAnim section2 slide-right">How to Open a Business Account?</h2>
                                <div className="customAnim section2 slide-right">
                                    <p>Please note that a Business Account can only be opened by the company's directors, or individuals with the power of attorney. </p>
                                    <p>To open such an account, you first have to register for a Personal Account. Then, you can initiate the Business Account opening process via the internet bank.</p>
                                </div>


                            </div>
                        </div>
                    </div>
                    {/* info section end */ }

                </div>
            </div>
        </Section>
        {/* onboard row end */ }
    </>;
};

export default OnBoarding;
